import { LANG_TO_SIMULATED_MARKET, LANGUAGE_OPTIONS } from '../../pages/playground/constants';
import { cn } from '../../utils/cn';

interface PlaygroundSettingsPanelProps {
  selectedLang: string;
  onSelectLang: (code: string) => void;
  modelConfigs: Array<{ key: string; label: string; isDefault: boolean }>;
  selectedModelConfig: string;
  onModelConfigChange: (key: string) => void;
  lastBrainModel: string | null;
}

export const PlaygroundSettingsPanel = ({
  selectedLang,
  onSelectLang,
  modelConfigs,
  selectedModelConfig,
  onModelConfigChange,
  lastBrainModel,
}: PlaygroundSettingsPanelProps) => {
  const simulatedMarket = LANG_TO_SIMULATED_MARKET[selectedLang];

  return (
    <>
      <div className="rounded-xl border border-black/10 bg-white p-5 shadow-sm">
        <h3 className="text-base font-semibold text-brand-blue">Marknadsspråk</h3>
        <p className="mt-1 text-xs text-text-grey">
          Sätter språket för hela sessionen. Startar om chatten.
        </p>
        {simulatedMarket ? (
          <p className="mt-1 text-xs font-medium text-brand-blue">
            Simulerar {simulatedMarket.hostname} ({simulatedMarket.currency})
          </p>
        ) : null}
        <div className="mt-3 grid grid-cols-5 gap-1.5">
          {LANGUAGE_OPTIONS.map((lang) => (
            <button
              key={lang.code}
              type="button"
              onClick={() => onSelectLang(lang.code)}
              title={lang.label}
              className={cn(
                'flex flex-col items-center gap-0.5 rounded-lg border py-2 text-center text-xs transition-colors',
                selectedLang === lang.code
                  ? 'border-brand-blue bg-brand-blue/10 font-semibold text-brand-blue'
                  : 'border-black/10 bg-brand-beige-tint-1 text-text-grey hover:border-brand-blue/40 hover:text-brand-blue',
              )}
            >
              <span className="text-base leading-none">{lang.flag}</span>
              <span className="font-mono text-[10px] uppercase">{lang.code}</span>
            </button>
          ))}
        </div>
      </div>

      {modelConfigs.length > 0 ? (
        <div className="rounded-xl border border-black/10 bg-white p-5 shadow-sm">
          <h3 className="text-base font-semibold text-brand-blue">Modell</h3>
          <p className="mt-1 text-xs text-text-grey">
            Hjärnans output-modell för kommande turer (endast playground/dev — live påverkas
            aldrig).
          </p>
          <select
            value={selectedModelConfig}
            onChange={(event) => onModelConfigChange(event.target.value)}
            className="mt-3 w-full rounded-lg border border-black/10 bg-brand-beige-tint-1 px-3 py-2 text-sm text-brand-blue focus:border-brand-blue focus:outline-none"
          >
            {modelConfigs.map((config) => (
              <option key={config.key} value={config.key}>
                {config.label}
              </option>
            ))}
          </select>
          {lastBrainModel ? (
            <p className="mt-2 text-xs text-text-grey">
              Senaste svar:{' '}
              <span className="font-mono font-medium text-brand-blue">{lastBrainModel}</span>
            </p>
          ) : null}
        </div>
      ) : null}
    </>
  );
};
